import React, { useState, useEffect } from "react";

const Hit = ({ point, onMove, onSave, onDragStart }) => {
    const [dragging, setDragging] = useState(false);
    const [currentX, setCurrentX] = useState(point.x);
    const [currentY, setCurrentY] = useState(point.y);

    useEffect(() => {
        const handleDragMove = (event) => {
            if (!dragging) return;

            let clientX, clientY;
            if (event.touches) {
                event.preventDefault(); // ✅ Fix: Prevent zooming
                clientX = event.touches[0].clientX;
                clientY = event.touches[0].clientY;
            } else {
                clientX = event.clientX;
                clientY = event.clientY;
            }

            onMove(point.id, clientX, clientY, setCurrentX, setCurrentY);
        };

        const handleDragEnd = (event) => {
            setDragging(false);
            onSave(point.id, currentX, currentY);
        };

        if (dragging) {
            document.addEventListener("mousemove", handleDragMove);
            document.addEventListener("mouseup", handleDragEnd);
            document.addEventListener("touchmove", handleDragMove, { passive: false }); // ✅ Fix: Prevent zooming
            document.addEventListener("touchend", handleDragEnd);
        }

        return () => {
            document.removeEventListener("mousemove", handleDragMove);
            document.removeEventListener("mouseup", handleDragEnd);
            document.removeEventListener("touchmove", handleDragMove);
            document.removeEventListener("touchend", handleDragEnd);
        };
    }, [dragging, currentX, currentY]);

    const handleDragStart = (event) => {
        event.preventDefault(); // ✅ Fix: Prevent default touch behavior (stops zoom)
        setDragging(true);
        onDragStart(point.id);
    };

    const getBackgroundColor = (currentX, currentY) => {
        const distance = Math.sqrt((currentX - 50) ** 2 + (currentY - 50) ** 2);

        if (distance < 17.2) return "bg-green-100 text-black";
        if (distance < 43.75) return "bg-orange-400 text-white ";
        return "bg-red-600 text-white ";
    };

    return (
        <div
            className={`absolute rounded-full w-8 h-8 flex items-center justify-center text-xs font-bold cursor-pointer touch-none
                ${getBackgroundColor(currentX, currentY)}  transition-transform`}
            style={{
                top: `${currentY}%`,
                left: `${currentX}%`,
                transform: "translate(-50%, -50%)"
            }}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
        >
            {point.id}
        </div>
    );
};

export default Hit;
